/**
 * 請求内容確認（user/bill）: 検索条件トグル + 請求月 DL エリアへの deep link スクロール
 * 参照: .cursor/skills/create-feature/references/04-ui-design/assets/js/content/content.js
 */
document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('bill') || !document.body.classList.contains('is-toggle')) {
    return;
  }

  const toggleBtn = document.getElementById('js-toggleBtn');
  if (toggleBtn) {
    const toggleGroup = toggleBtn.closest('.togglegroupVox');
    if (toggleBtn.classList.contains('is-open') && toggleGroup) {
      const toggleTarget = toggleGroup.querySelector('.toggletarget');
      if (toggleTarget) {
        toggleTarget.classList.add('is-open');
      }
    }
    toggleBtn.addEventListener('click', () => {
      toggleBtn.classList.toggle('is-open');
      if (toggleGroup) {
        const toggleTarget = toggleGroup.querySelector('.toggletarget');
        if (toggleTarget) {
          toggleTarget.classList.toggle('is-open');
        }
      }
    });
  }

  scrollToBillingsDownloadAnchorIfNeeded();
});

/**
 * 画面上部を覆う fixed/sticky バー（.loginNameVox / #siteHeader）の下端オフセット。
 * 左サイドレール型の #siteHeader（高さほぼ viewport）は対象外。
 *
 * @returns {number} scrollY から差し引くピクセル（余白込み）
 */
function userBillingsTopOverlayOffsetPx() {
  const breathingRoomPx = 16;
  let offsetPx = breathingRoomPx;
  const overlayCandidates = [
    document.getElementById('siteHeader'),
    document.querySelector('.loginNameVox'),
  ];

  for (const overlayElement of overlayCandidates) {
    if (!(overlayElement instanceof HTMLElement)) {
      continue;
    }

    const computedStyle = window.getComputedStyle(overlayElement);
    if (computedStyle.position !== 'fixed' && computedStyle.position !== 'sticky') {
      continue;
    }

    const overlayRect = overlayElement.getBoundingClientRect();
    const isTopStripOverlay =
      overlayRect.top <= 1 &&
      overlayRect.bottom > 0 &&
      overlayRect.height < window.innerHeight * 0.5;
    if (!isTopStripOverlay) {
      continue;
    }

    offsetPx = Math.max(offsetPx, Math.ceil(overlayRect.bottom) + breathingRoomPx);
  }

  return offsetPx;
}

/**
 * メール deep link の focus=billing_download のとき、請求月 DL ブロックへ
 * ヘッダーに隠れない位置までスクロールする。
 * （#hash は未ログイン→/login リダイレクト時にブラウザが保持しログイン画面を壊すため使わない）
 *
 * @returns {void}
 */
function scrollToBillingsDownloadAnchorIfNeeded() {
  const focusParam = new URLSearchParams(window.location.search).get('focus');
  if (focusParam !== 'billing_download') {
    return;
  }

  const downloadBlock = document.getElementById('ur-billings-download');
  if (!(downloadBlock instanceof HTMLElement)) {
    return;
  }

  const topOverlayOffsetPx = userBillingsTopOverlayOffsetPx();
  const targetScrollTop =
    downloadBlock.getBoundingClientRect().top + window.scrollY - topOverlayOffsetPx;
  window.scrollTo({ top: Math.max(0, targetScrollTop), behavior: 'auto' });
}
